import { TranslationKeys } from '@/localization';
import { FC, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { SelectHint } from './SelectHint';

type SelectFooterProps = {
  hint: TranslationKeys | undefined;
  error: string | undefined;
  classNames?: {
    wrapper?: string;
    error?: string;
    hint?: string;
  };
};

const SelectFooterComp: FC<SelectFooterProps> = ({ error, hint, classNames }) => {
  return (
    <>
      {error || hint ? (
        <div className={twMerge('text-sm', classNames?.wrapper)}>
          {error ? (
            <p className={twMerge('text-red-600', classNames?.error)}>{error}</p>
          ) : hint ? (
            <SelectHint hint={hint} className={classNames?.hint} />
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export const SelectFooter = memo(SelectFooterComp);
